import React, { useEffect } from "react";
import { usePricingIntegration } from "../../hooks/usePricingIntegration";
import { bootstrapPricing } from "@configs/currencies";
import { pricingApi } from "src/services/api";

/**
 * Integration component for real-time server-side pricing calculation
 * Place this component at the app level to automatically handle pricing updates
 * when photo groups or product quantities change
 */
export const PricingIntegrationProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { error } = usePricingIntegration();

  useEffect(() => {
    if (error) {
      console.warn("Pricing calculation error:", error);
    }
  }, [error]);

  // Sync local pricing tables with backend on first mount. Existing components
  // keep using the synchronous getters in `currencies.ts`; values are now
  // backed by /pricing/shipping and /pricing/photo-options.
  useEffect(() => {
    bootstrapPricing(pricingApi);
  }, []);

  return <>{children}</>;
};

export default PricingIntegrationProvider;
